const client_id = 'Inavista.js';
const sso_redirect_url = 'https://test.accounts.inavista.com/auth';
const scope = 'openid%20profile%20Roles';
const state = 'cC7BRH8TDiRbOIaM'; 
const authAppUrl = 'https://test.accounts.inavista.com';

export const environment = {
    production: false,
    stage: false,
    development: false,
    testDevelopment: true,
    resetPasswordURL: `${authAppUrl}/setup-new-password`,
    appUrl: 'https://test-rims.inavista.com/auth',
    appApiUrl: 'https://test-api-01-rims.inavista.com/api/',
    apiUrl: 'https://test-webauth.inavista.com/api/',
    redirectUrl: 'https://sso1beta.snapon.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3DMobileApp.js%26redirect_uri%3Dhttps%253A%252F%252Ftest-rims.inavista.com%252Fauth%26response_type%3Did_token%2520token%26scope%3Dopenid%2520profile%2520Roles%26state%3D16414008400430.ruvtjl5vfu%26nonce%3D16414008400430.usnkl95geh',
    syncfusionLicenseKey: 'Ngo9BigBOggjHTQxAR8/V1NAaF1cXmhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjW31WcHNXQ2RVV0xwVw==',
    ssoAuthorizationUrl: `https://login.snapon.com/connect/authorize?
        response_type=code
        &client_id=${client_id}
        &redirect_uri=${sso_redirect_url}
        &scope=${scope}
        &state=${state}
    `,
};